module.exports = __webpack_public_path__ + "static/media/SF_bm_engl_sentrert_logo_innlandet_neg.5338d3f2.png";